
import XButton from 'vux/src/components/x-button/index.vue'

import WxHeader from '../Header'
import WxFooter from '../Footer'

export default {

components: {
WxHeader,
WxFooter,
XButton
},
data () {
return {
tag: '',
index:0,
auth_msg : '正在操作，请稍后...',
}
},
created(){
/*
path: '/detail/:id/'
console.log(this.$route);
console.log('code-'+this.$route.params.code);
console.log('state-'+this.$route.params.state);

console.log('code-'+this.$route.query.code);
console.log('state-'+this.$route.query.state);
*/
let code = this.$route.query.code;
let state = this.$route.query.state;
if(code){
this.auth_msg = '授权成功，即将跳转';
this.save_wx_code(code,state);
/*setTimeout(() => {
window.location.href = '/Login';
}, 3000)*/

}

},
methods:{
}
}



// WEBPACK FOOTER //
// ./src/components/weixin/Login.vue